import { api } from '../../lib/api';
import type { LocalizedText } from '../../lib/localized-text';

export interface Banner {
  id: string;
  message: LocalizedText;
  isActive: boolean;
}

export type BannerPayload = {
  message: Partial<LocalizedText>;
  isActive: boolean;
};

export async function getActiveBanner(): Promise<Banner | null> {
  const { data } = await api.get('/banner');
  return data;
}

export async function getBannerForAdmin(): Promise<Banner | null> {
  const { data } = await api.get('/banner/admin');
  return data;
}

export async function updateBanner(payload: BannerPayload): Promise<Banner> {
  const { data } = await api.put('/banner', payload);
  return data;
}
